import './App.css';
import { Route, Routes, Outlet} from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "./layout/Navbar";
import Footer from "./layout/Footer";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AnonymousRoutes from "./components/AnonymousRoutes";
import AuthenticatedRoutes from "./components/AuthenticatedRoutes";
import AdminRoutes from "./components/AdminRoutes"; // New Admin Route Wrapper
import AdminOrderManagement from './pages/AdminOrderManagement';
import ProfilePage from './pages/ProfilePage';
import EditProfilePage from './pages/EditProfilePage';
import CartPage from "./pages/CartPage";
import CartCheckoutPage from "./pages/CartCheckoutPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage";
import OrderHistoryPage from "./pages/OrderHistoryPage";
import ProductDetailPage from "./pages/ProductDetailPage";

function Layout() {
    return (
        <div className="flex flex-col h-screen justify-between">
            <ToastContainer
                position="top-left"
                theme="light"
                pauseOnHover
                autoClose={1500}
            />

            <Navbar />
            <main className="mb-auto w-10/12 max-w-5xl mx-auto">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}

function App() {
    const isAuth = useSelector((state) => state.user?.isAuth);
    const isAdmin = useSelector((state) => state.user?.isAdmin);
    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                <Route index element={<LandingPage />} />
                <Route path="/product/:id" element={<ProductDetailPage />} />
                {/* Registering Authenticated Routes */}
                <Route element={<AdminRoutes isAuth={isAuth} isAdmin={isAdmin} />}>
                    <Route path="/admin/orders" element={<AdminOrderManagement />} />
                </Route>

                {/* Registering Authenticated Routes */}
                <Route element={<AuthenticatedRoutes isAuth={isAuth} isAdmin={isAdmin} />}>
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/profile/edit" element={<EditProfilePage />} />
                    <Route path="/cart" element={<CartPage />} />
                    <Route path="/cart/checkout" element={<CartCheckoutPage />} />
                    <Route path="/order/confirmation" element={<OrderConfirmationPage />} />
                    <Route path="/order/history" element={<OrderHistoryPage />} />
                </Route>

                {/* Registering Anonymous Routes */}
                <Route element={<AnonymousRoutes isAuth={isAuth} isAdmin={isAdmin} />}>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                </Route>
            </Route>
        </Routes>
    );
}

export default App;
